import Slider from 'react-slick'
import { createUseStyles } from 'react-jss'
import { merge } from 'lodash'
import Link from 'next/link'
import clsx from 'clsx'

const useStyles = createUseStyles({
    hItem: {
        textAlign: 'center',
        '& .imgItem': {
            width: '100px !important',
            padding: 5,
            borderRadius: '50%',
            border: 2,
            margin: '0 auto 1rem auto',
        },
        '&.newItem .imgItem ': {
            backgroundImage:
                'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
        },
    },
})

function Highlight(props) {
    const settings = merge(
        {},
        {
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 5,
            slidesToScroll: 1,
            rtl: true,
            items: [],
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2,
                        initialSlide: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
            ],
        },
        props
    )
    const classes = useStyles()

    return (
        //BUG hSlider is not defined
        <div className={`text-center p-3 ${classes.hSlider}`}>
            <Slider {...settings}>
                {settings.items.map((i, idx) => (
                    <div
                        key={idx}
                        className={clsx(classes.hItem, i.isNew && 'newItem')}>
                        <Link href={i.href || ''}>
                            <a>
                                <div className='imgItem'>
                                    <img
                                        src={i.img_path ? `/api/${i.img_path}` : '/img/logo.jpeg'}
                                        className='rounded-full mx-auto shadow-md'
                                        alt={i.title}
                                    />
                                </div>
                                <p>{i.title}</p>
                            </a>
                        </Link>
                    </div>
                ))}
            </Slider>
        </div>
    )
}

export { Highlight }
